<template>
    <div :id="'d-viewer-holder-' + id" class="w-100 d-document-viewer" >
        <div class="" :class="asModal ? 'no-border' : ''" :id="id">
            <d-loader v-if="loading"></d-loader>        
            <d-row v-if="!loading && is_valid" class="d-document-viewer-header">
                <d-col>
                    <d-button v-for="btn in buttons" :key="btn.id" :icon="btn.icon" :title="btn.tooltip" @click="btn.click" :disabled="btn.disabled" :variant="action_btn_variant" class="document-button" ></d-button>
                </d-col>
                <d-col v-if="is_PDF && pdf.pages > 0 && !allPages"  class="text-end pager">
                    <d-button :disabled="pdfPageLeftEnable" :icon="icons.document_icons.page_left"  @click="pdfpage(-1)" :variant="page_btn_variant" class="document-button" ></d-button>
                    <span class="mx-2"><d-text>PAGE</d-text> {{ pdf.page}}/{{ pdf.pages }}</span>
                    <d-button :disabled="pdfPageRightEnable" :icon="icons.document_icons.page_right" @click="pdfpage(1)" :variant="page_btn_variant" class="document-button" ></d-button>
                </d-col>             
            </d-row>    
            <div v-if="!loading" class="d-document-viewer-content" :style="viewheight">
                <d-image v-if="is_image" 
                    :src="Url"
                    :rotate="image.rotation"
                    :zoom="image.scale"
                    :print="image.print"
                     @loaded="imageLoaded"
                />                
                <VuePdfEmbed v-else-if="is_PDF"   
                    ref="pfdviewerref"                 
                    text-layer
                    :source="Url" 
                    @loaded="pdfLoaded"
                    :page="pdf_page"
                    :rotation="pdf.rotation"
                    :scale="pdf.scale"
                    :width="pdfWidth * pdf.scale"
                    :height="height"
                />
                <d-alert variant="danger" v-else-if="!loading && !is_image && !is_PDF"><d-text>{{ errorMessage }}</d-text></d-alert>
            </div>
        </div>
    </div>
</template>


<script setup>

//import { reactive, ref, computed, defineProps, defineEmits, toRefs, onMounted, onBeforeUnmount, watch } from 'vue'

import { reactive, ref, computed, defineProps, defineEmits, onMounted, getCurrentInstance } from 'vue'
// import PDF from "pdf-vue3";
import VuePdfEmbed from 'vue-pdf-embed'
import icons from "@/dod/enums/dicons";

const { appContext } = getCurrentInstance()
const dfilehelper = appContext.config.globalProperties.$dfilehelper;

const pfdviewerref = ref("pfdviewerref");
const action_btn_variant = 'outline-primary';
const page_btn_variant = 'outline-primary';

// import { useStackedTabsStore } from '@/dod/store/dwebsocket'
// const stackedstore = useStackedTabsStore()

const emit = defineEmits(['init','pdfLoaded', 'imageLoaded', 'floatchange', 'Close', 'rotate', 'zoom', 'pageChanged']);

// PROPS
const props =  defineProps({
    url: { type: String, required: false },
    pdfBase64String: { type: String, required: false },
    imageBase64String: { type: String, required: false },
    asModal: { type: Boolean, required: false, default: false },    
    errorMessage: { type: String, required: false, default: 'DViewer_Select_Document'},
    filename : { type: String, required: false, default: null},
    allPages: { type: Boolean, required: false, default: false}
})

// DATA
// Using reactive for objects with nested properties
const image = reactive({
    scale: 1,
    zoomstep: 0.1,
    rotation: 0,
    print: false
});

const pdf = reactive({
    page: 1,
    pages: 1,
    zoomstep: 0.1,
    scale: 1,
    rotation: 0
});


// // Using ref for primitives or simple values
const pdfWidth = ref('');
const id = ref(Math.floor(Math.random() * 100000000) + '_dod_document_holder');
const loading = ref(true);
// const setasstacked = ref(false);
const floatingdoc = ref(false);
const Url = ref('');
const FromBase64 = ref(false);
const MimeType = ref(null);
// const File = ref(null);

// Computed

const buttons = computed(() => {
    var btns = [];

    btns.push({ id:'RotateBtn', icon: icons.document_icons.rotate, click: () => rotate(90), disabled: false, tooltip: 'Rotate' });
    btns.push({ id:'ZoomInBtn', icon: icons.document_icons.zoom_in, click: zoomIn, disabled: false, tooltip: 'Zoom_In' });
    btns.push({ id:'ZoomResetBtn', icon: icons.document_icons.zoom_reset, click: resetzoom, disabled: false, tooltip: 'Zoom_Reset' });
    btns.push({ id:'ZoomOutBtn', icon: icons.document_icons.zoom_out, click: zoomOut, disabled: false, tooltip: 'Zoom_Out' });    
    btns.push({ id:'DownloadBtn', icon: icons.document_icons.download, click: downloadDocument, disabled: false, tooltip: 'Download' });
    btns.push({ id:'PrintBtn', icon: icons.document_icons.print, click: printDocument, disabled: false, tooltip: 'Print' });
    btns.push({ id:'OpenExternal', icon: icons.document_icons.external, click: open, disabled: false, tooltip: 'Open_External' });

    return btns;
})

const is_valid = computed(() => is_image.value || is_PDF.value);

const file_name = computed(() => props.filename ??  dfilehelper.getFilenameFromUrl(Url.value))
const file_extension = computed(() => dfilehelper.getFileNameExtension(file_name.value))

const is_image = computed(() => {
  const images = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
  return images.includes(MimeType.value);
});
const is_PDF = computed(() => MimeType.value === 'application/pdf');
const pdfPageLeftEnable = computed(() => pdf.page === 1 ? true : false);
const pdfPageRightEnable = computed(() => pdf.page === pdf.pages ? true: false);
const pdf_page = computed(() => props.allPages ? null : pdf.page);

// const activetabid = computed(() => stackedstore.activeid);

const height = computed(() => {
    if (loading.value)
        return 0;

    if (props.asModal)
        return 'auto';

    const wh = window.innerHeight;
    const toppos = document.getElementById(id.value).getBoundingClientRect().top;

    if (floatingdoc.value) {
        return wh - 250;
    } else if (props.asModal) {
        return wh - 250;
    }

    return wh - toppos - 100;
});

const viewheight = computed(() => {
    if (loading.value) {
        return;
    }

    var h = height.value;
    var sub = "px";
    if (isNaN(h))
        sub = "";

    return `height: ${h}${sub};`;
});

const viewWidth = computed(() => {
    const width = document.getElementById(id.value).getBoundingClientRect().width - 60;
    return width;
});


// Methods
const init = async () => {
  pdfWidth.value = viewWidth.value;
  loading.value = false;
  FromBase64.value = false;

    if(props.url){
        Url.value = props.url;       
        MimeType.value = dfilehelper.getMimeTypeFromExtension(file_extension.value);
    }  
    else if (props.pdfBase64String) {
        Url.value = props.pdfBase64String;
        MimeType.value = 'application/pdf';
        FromBase64.value = true;
    } 
    else if (props.imageBase64String) {
        Url.value = props.imageBase64String;
        MimeType.value = 'image/png';
        FromBase64.value = true;
    }
    loading.value = false;
    emit("init");
}

const rotate = async (degrees) => {
    if(is_PDF.value)
        pdf.rotation += degrees;
    else if(is_image.value)
        image.rotation += degrees;
    emit('rotate', degrees)   
};

const zoomIn = () => {
    if (is_PDF.value) {
        pdf.scale += pdf.zoomstep;
    }
    else if (is_image.value) {
        image.scale += image.zoomstep;
    } 
    emit('zoom', pdf.zoomstep)
};

const zoomOut = () => {
    if (is_PDF.value) {
        pdf.scale -= pdf.zoomstep;
    }
    else if (is_image.value) {
        image.scale -= image.zoomstep;
    } 
    emit('zoom', -pdf.zoomstep)
};

const resetzoom = () => {
    pdf.scale = 1;
    image.scale = 1;
};

const pdfpage = (direction) => {
  if (!is_PDF.value) return;

  if (direction > 0) {
    pdf.page++;
    if (pdf.page > pdf.pages) pdf.page = pdf.pages;
  } else {
    pdf.page--;
    if (pdf.page < 1) pdf.page = 1;
  }
  emit('pageChanged', pdf.page)
};

const imageLoaded = () => {  
//   if (setasstacked.value) {
//     setTimeout(() => {
//       SetAsStackedTab();
//     }, 750);
//   }
  emit('imageLoaded')
};

const pdfLoaded = (event) => {
  pdf.pages = event._pdfInfo.numPages;
  loading.value = false;
  pdf.page = 1;
  // emit('documentloaded');
//   if (setasstacked.value) {
//     setTimeout(() => {
//       SetAsStackedTab();
//     }, 750);
//   }
  emit('pdfLoaded')
};

const downloadDocument = () => {
    var name = dfilehelper.getFilenameFromUrl(Url.value);
    if (is_PDF.value) {
        pfdviewerref.value.download(name);
    }
    else if(is_image.value){
        dfilehelper.saveUrl(Url.value, name);
    } else {
        dfilehelper.downloadBase64File(Url.value, name);
    }
};

const printDocument = () => {
    var name = dfilehelper.getFilenameFromUrl(Url.value);
    if (is_PDF.value) {
        pfdviewerref.value.print(300, name, true);
    } else {
        image.print = true;
        setTimeout(() => {
            document.body.appendChild(document.getElementById("d-printable-image"));        
            window.print();    
        }, 500);        
    }
};

const open = () => {
    dfilehelper.openUrlInNewTab(Url.value);
};

// const deleteDocument = () => {
//   // Handle document deletion
// };

// const Close = () => {
//   // Emit Close event
//   emit('Close');
// };

// const AsStackedTab = () => {
//   setasstacked.value = true;
// };

// const SetAsStackedTab = () => {
//   store.commit('stackedtabs/AddTab', {
//     id: id.value,
//     holderid: `d-viewer-holder-${id.value}`,
//     name: 'Underlag',
//     icon: '',
//     classname: 'yellow'
//   });

//   const element = document.getElementById(id.value);
//   element.classList.add('d-none');
//   let sidebarW = document.getElementById('sidebar').offsetWidth;

//   if (sidebarW < 100) {
//     sidebarW = 100;
//   }

//   element.style.minWidth = `${window.innerWidth - sidebarW - 10}px`;
//   floatingdoc.value = true;
//   setasstacked.value = false;
//   emit('floatchange', floatingdoc.value);
// };

// const ClearStacked = () => {
//   setasstacked.value = false;
//   stackedstore.SetActive(false)
//   stackedstore.RemoveTab(id)

//   const element = document.getElementById(id.value);
//   if (!element) return;

//   element.classList.remove('d-none');
//   element.style.minWidth = 'initial';

//   const holder = document.getElementById(`d-viewer-holder-${id.value}`);
//   if (!holder) return;

//   holder.appendChild(element);
//   floatingdoc.value = false;
//   emit('floatchange', floatingdoc.value);
// };


// /// WATCH
// watch(
//   [() => documentId, () => pdfBase64String, () => imageBase64String],
//   () => {
//     init();
//   }
// )

// // Empty watch for computed value "activeTabId"
// // watch(activetabid, (newVal) => {
// //   // if (newVal === id.value && !floatvisible.value) {
// //   //   loading.value = false;
// //   // }
// // });

onMounted(() => {
    init();

    window.onafterprint = function () {
       image.print = false;       
    };
});

// onBeforeUnmount(() => {
//     ClearStacked();
// });

</script>